export default {"src":"/_next/static/media/icon_favourite_hovered.d80a06a5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};